import { render } from "./ReportTransactionActivity.vue?vue&type=template&id=151dc066&scoped=true"
import script from "./ReportTransactionActivity.vue?vue&type=script&lang=js"
export * from "./ReportTransactionActivity.vue?vue&type=script&lang=js"

import "./ReportTransactionActivity.vue?vue&type=style&index=0&id=151dc066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151dc066"]])

export default __exports__